import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Navimumbaitaxtservice() {



  const cardData = {
    keyword: " Navi Mumbai Taxi Service   ",


"headingDescription": "Royal Route Cab offers reliable Navi Mumbai taxi service, providing safe, comfortable, and affordable travel solutions for local rides, airport transfers, corporate travel, and outstation journeys. Whether you need a quick city ride, daily commute, or long-distance trip, our professional drivers and well-maintained vehicles ensure a smooth and stress-free experience. Our services are available 24/7 with easy booking, punctual pickups, and transparent pricing with no hidden charges. We offer a wide range of vehicles including hatchbacks, sedans, SUVs, Innova, Ertiga, Kia Carens, Innova Crysta, and Tempo Travellers suitable for all travel needs. With doorstep pickup, clean cars, and experienced chauffeurs, Royal Route Cab is a trusted choice for taxi service in Navi Mumbai.",

"topPlaces": [
  {
    "title": "Local City Travel in Navi Mumbai",
    "description": "Taxi service in Navi Mumbai is widely used for daily commuting across areas like Vashi, Nerul, Belapur, Kharghar, Panvel, and Airoli. It provides a convenient and time-saving alternative to public transport, especially for office travel, shopping, and personal work. With 24/7 availability and door-to-door pickup, passengers can travel comfortably without waiting or changing multiple transport modes. Professional drivers ensure safe navigation through city traffic, making local taxi service one of the most preferred transport options."
  },
  {
    "title": "Airport Transfers (Mumbai & Navi Mumbai Airport)",
    "description": "Airport taxi service is one of the most demanded services in Navi Mumbai, offering timely pickup and drop to both Mumbai International Airport and Navi Mumbai Airport. With flight tracking, drivers adjust pickup timing according to delays or early arrivals, ensuring passengers never miss their flight. Comfortable vehicles, luggage space, and professional service make airport travel smooth and stress-free for families, business travelers, and tourists."
  },
  {
    "title": "Outstation Travel from Navi Mumbai",
    "description": "Navi Mumbai taxi services provide reliable outstation travel to popular destinations like Pune, Lonavala, Shirdi, Nashik, Mahabaleshwar, Surat, and Gujarat. Travelers can choose one-way or round-trip options based on their needs. These services are ideal for weekend getaways, family vacations, and pilgrimage trips, offering comfortable vehicles and experienced drivers for long-distance journeys. :contentReference[oaicite:0]{index=0}"
  },
  {
    "title": "Corporate Taxi Services",
    "description": "Corporate taxi services in Navi Mumbai are designed for business professionals, offering punctual, professional, and comfortable travel for meetings, airport transfers, and employee transportation. Companies prefer these services due to reliable scheduling, clean vehicles, and experienced drivers, ensuring a premium travel experience for executives and clients."
  },
  {
    "title": "One Way & Round Trip Cabs",
    "description": "Taxi services offer flexible booking options including one-way trips and round trips, allowing customers to choose according to their travel plans. One-way cabs are cost-effective for single-direction travel, while round-trip bookings are ideal for return journeys, sightseeing, or multi-day travel plans without the hassle of rebooking."
  },
  {
    "title": "Hourly Rental & Full-Day Booking",
    "description": "Passengers can book taxis on an hourly basis or for full-day usage, making it perfect for city tours, business meetings, shopping, and events. This option provides flexibility to travel multiple locations without booking separate rides, ensuring convenience and better time management. :contentReference[oaicite:1]{index=1}"
  },
  {
    "title": "Family & Group Travel",
    "description": "For families and groups, Navi Mumbai taxi services provide spacious vehicles like SUVs, Innova, and Tempo Travellers. These vehicles offer comfortable seating, extra luggage space, and smooth ride quality, making group travel convenient without the need for multiple cars."
  },
  {
    "title": "24/7 Cab Availability",
    "description": "Taxi services in Navi Mumbai operate round the clock, ensuring availability for early morning, late-night, and emergency travel needs. This makes them highly reliable for airport transfers, urgent travel, and last-minute bookings without any inconvenience."
  },
  {
    "title": "Online & Instant Booking",
    "description": "Modern taxi services offer easy online booking through websites, WhatsApp, or phone calls, allowing customers to book rides instantly. Quick confirmation, driver details, and fare transparency make the booking process simple and user-friendly. :contentReference[oaicite:2]{index=2}"
  },
  {
    "title": "Safe & Sanitized Travel",
    "description": "Taxi providers maintain high safety standards with verified drivers, GPS-enabled vehicles, and regular sanitization. Clean cars, insured vehicles, and professional service ensure a safe and comfortable travel experience for all passengers. :contentReference[oaicite:3]{index=3}"
  }
],






services: [
  {
    name: "Navi Mumbai Taxi Service",
    description: "Navi Mumbai taxi service offers reliable and comfortable travel for local, airport, and outstation trips. Ideal for daily commuters, families, and business travelers, this service ensures timely pickups. Professional drivers and clean vehicles enhance comfort. It guarantees a smooth travel experience."
  },
  {
    name: "Cab Service in Navi Mumbai",
    description: "Cab service in Navi Mumbai provides convenient and flexible transportation across all areas. This service is suitable for local travel, office commutes, and airport transfers. Well-maintained vehicles ensure safety. It guarantees a hassle-free ride."
  },
  {
    name: "Taxi Service in Navi Mumbai",
    description: "Taxi service in Navi Mumbai ensures dependable travel with professional drivers and comfortable vehicles. This service is ideal for city travel and short-distance trips. Flexible booking enhances convenience. It guarantees a reliable journey."
  },
  {
    name: "Navi Mumbai Taxi",
    description: "Navi Mumbai taxi offers quick and easy transportation for all travel needs. This service includes local rides, airport transfers, and outstation trips. Comfortable seating ensures a pleasant experience. It guarantees convenience."
  },
  {
    name: "Taxi in Navi Mumbai",
    description: "Taxi in Navi Mumbai provides efficient and affordable travel options for individuals and groups. This service ensures easy availability and professional service. It guarantees a smooth and comfortable ride."
  },
  {
    name: "Navi Mumbai Cab Service",
    description: "Navi Mumbai cab service offers reliable travel solutions with multiple vehicle options. Ideal for personal and business travel. Clean vehicles and trained drivers ensure comfort. It guarantees a safe journey."
  },
  {
    name: "Vashi Taxi Service",
    description: "Vashi taxi service provides quick and reliable rides within Vashi and nearby areas. Ideal for local commuting and office travel. Professional drivers ensure safety. It guarantees a convenient travel experience."
  },
  {
    name: "Nerul Taxi Service",
    description: "Nerul taxi service offers comfortable and timely transportation for local and outstation travel. This service ensures easy availability of cabs. Clean vehicles enhance comfort. It guarantees a smooth ride."
  },
  {
    name: "Belapur Taxi Service",
    description: "Belapur taxi service provides dependable transportation for daily travel and airport transfers. This service is ideal for residents and office commuters. Professional drivers ensure punctuality. It guarantees a reliable experience."
  },
  {
    name: "Kharghar Taxi Service",
    description: "Kharghar taxi service offers convenient travel solutions for local and long-distance trips. Ideal for families and professionals. Comfortable vehicles ensure a pleasant journey. It guarantees smooth travel."
  },
  {
    name: "Panvel Taxi Service",
    description: "Panvel taxi service provides quick and affordable transportation for city and outstation travel. This service ensures timely pickups and drops. Professional drivers enhance safety. It guarantees a reliable journey."
  },
  {
    name: "Online Taxi Booking Navi Mumbai",
    description: "Online taxi booking Navi Mumbai provides a fast and convenient way to book cabs. Customers can choose vehicle type and timing easily. Instant confirmation ensures availability. It simplifies travel planning."
  },
  {
    name: "Book Taxi Service in Navi Mumbai",
    description: "Book taxi service in Navi Mumbai with easy online booking and flexible travel options. Customers can select preferred vehicles and schedules. Transparent pricing ensures trust. It ensures hassle-free booking."
  },
  {
    name: "Best Taxi Service in Navi Mumbai",
    description: "Best taxi service in Navi Mumbai ensures top-quality vehicles, professional drivers, and excellent customer support. This service focuses on comfort, safety, and punctuality. It guarantees a premium travel experience."
  },
  {
    name: "Cheapest Taxi Service in Navi Mumbai",
    description: "Cheapest taxi service in Navi Mumbai offers budget-friendly travel without compromising comfort. Transparent pricing ensures no hidden charges. Ideal for cost-conscious travelers. It ensures economical travel."
  },
  {
    name: "24x7 Taxi Service in Navi Mumbai",
    description: "24x7 taxi service in Navi Mumbai provides round-the-clock availability for all travel needs. This service is ideal for late-night and early-morning travel. Quick booking ensures convenience. It guarantees service anytime."
  },
  {
    name: "Navi Mumbai Airport Taxi Service",
    description: "Navi Mumbai airport taxi service offers reliable pickup and drop services for airport travel. Professional drivers ensure timely service. Comfortable vehicles enhance convenience. It guarantees a stress-free journey."
  },
  {
    name: "Airport Taxi Navi Mumbai",
    description: "Airport taxi Navi Mumbai provides quick and efficient transportation to and from the airport. This service ensures timely pickups and comfortable travel. It guarantees a smooth airport transfer."
  },
  {
    name: "Innova Crysta Navi Mumbai Taxi Service",
    description: "Innova Crysta Navi Mumbai taxi service offers premium and spacious travel for families and corporate clients. Luxury interiors and smooth performance enhance comfort. It ensures a high-end travel experience."
  }
],

tableData: [
  ["Navi Mumbai Taxi Service", "Cab Service in Navi Mumbai"],
  ["Taxi Service in Navi Mumbai", "Navi Mumbai Taxi"],
  ["Taxi in Navi Mumbai", "Navi Mumbai Cab Service"],
  ["Vashi Taxi Service", "Nerul Taxi Service"],
  ["Belapur Taxi Service", "Kharghar Taxi Service"],
  ["Panvel Taxi Service", "Online Taxi Booking Navi Mumbai"],
  ["Book Taxi Service in Navi Mumbai", "Best Taxi Service in Navi Mumbai"],
  ["Cheapest Taxi Service in Navi Mumbai", "24x7 Taxi Service in Navi Mumbai"],
  ["Navi Mumbai Airport Taxi Service", "Airport Taxi Navi Mumbai"],
  ["Innova Crysta Navi Mumbai Taxi Service", ""]
],


whychoose: [
  {
    WhyChooseheading: "Reliable Navi Mumbai Taxi Service",
    WhyChoosedescription: "Royal Route Cabs offers dependable taxi service in Navi Mumbai for local travel, airport transfers, and outstation trips."
  },
  {
    WhyChooseheading: "Professional & Experienced Drivers",
    WhyChoosedescription: "Our drivers are well-trained and experienced in Navi Mumbai routes, ensuring safe and timely travel."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "We provide clear and upfront pricing with no hidden costs, ensuring complete fare transparency."
  },
  {
    WhyChooseheading: "24/7 Taxi Availability",
    WhyChoosedescription: "Our Navi Mumbai taxi service operates round the clock, allowing you to book rides anytime for daily or urgent travel needs."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned for a comfortable ride experience."
  },
  {
    WhyChooseheading: "Local & Outstation Travel Options",
    WhyChoosedescription: "We provide taxi services for local Navi Mumbai travel, Mumbai airport transfers, and outstation journeys."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and mini buses."
  },
  {
    WhyChooseheading: "Trusted Taxi Service Provider",
    WhyChoosedescription: "Royal Route Cabs is trusted by customers for reliable and punctual taxi service in Navi Mumbai."
  }
]

};

const faqData = [
  { question: "Do you provide taxi service in Navi Mumbai?", answer: "Yes, Royal Route Cabs offers reliable taxi services across Navi Mumbai for local and outstation travel." },
  { question: "Is taxi service available 24 hours?", answer: "Yes, our Navi Mumbai taxi service operates 24/7." },
  { question: "Do you provide airport taxi service?", answer: "Yes, we offer Mumbai and Navi Mumbai airport pickup and drop services." },
  { question: "Which areas do you cover?", answer: "We cover Vashi, Nerul, Belapur, Kharghar, Panvel, Airoli, and all nearby locations." },
  { question: "Which vehicles are available?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, Tempo Travellers, and mini buses." },
  { question: "Can I book taxi for outstation travel?", answer: "Yes, we provide outstation taxi services from Navi Mumbai to various destinations." },
  { question: "Is pricing transparent?", answer: "Yes, we provide clear pricing with no hidden charges." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from home, hotel, and office anywhere in Navi Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for peak hours and long-distance travel." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Jadhav",
    feedback: "Navi Mumbai taxi service with Royal Route Cabs was very reliable and punctual. The ride experience was smooth and comfortable throughout the city travel.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priya Deshmukh",
    feedback: "Great local taxi service in Navi Mumbai. The cab was clean, the driver was professional, and the overall experience felt safe and hassle-free.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai Taxi Service",
  "image": "https://www.royalroutecabs.com/assets/images/navi-mumbai-taxi-service.jpg", // replace if needed
  "description": "Book Navi Mumbai taxi service with Royal Route Cabs for safe, affordable, and reliable local and outstation travel. Available 24x7 across Vashi, Nerul, Belapur, Kharghar, Panvel, and airport routes with sedan, SUV, Innova, Ertiga, and premium vehicles.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "99/km", // indicative pricing (adjust as per your model)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/navi-mumbai-taxi-service"
  }
};








  return (
    <div>
<Helmet>
  <title>Navi Mumbai Taxi Service | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Navi Mumbai taxi service with Royal Route Cabs. 24x7 reliable local and outstation cab service across Vashi, Nerul, Belapur, Kharghar, Panvel and airport routes."
  />

  <meta
    name="keywords"
    content="navi mumbai taxi service, cab service in navi mumbai, taxi service in navi mumbai, navi mumbai taxi, taxi in navi mumbai, navi mumbai cab service, vashi taxi service, nerul taxi service, belapur taxi service, kharghar taxi service, panvel taxi service, online taxi booking navi mumbai, book taxi service in navi mumbai, best taxi service in navi mumbai, cheapest taxi service in navi mumbai, 24x7 taxi service in navi mumbai, navi mumbai airport taxi service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/104.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaitaxtservice;